<template>
  <div>
    <b-container class="portfolio">
      <h2>{{title}}</h2>
      <b-row align-v="center">
        <b-col class="photo-col" cols="4" v-for="(item, idx) in items" :key="item.id">
          <div class="photo-block" v-bind:style="item.thumbStyle" v-on:click="select(idx)"><div></div></div>
        </b-col>
      </b-row>
    </b-container>
    <slideshow v-if="selected > -1" v-bind:items="items" v-bind:selected="selected" v-on:close="selected = -1"></slideshow>
  </div>
</template>

<script>
import Slideshow from './Slideshow.vue'
export default {
  name: 'portfolio',
  data () {
    return {
      title: '',
      selected: -1,
      showSlides: false,
      items: []
    }
  },
  created () {
    this.init(this.$route.params.selection)
  },
  watch: {
    '$route.params.selection': function (selection) {
      this.init(selection)
    },
    'selected': function (idx) {
      if (idx > -1) {
        document.body.className = 'slideshow'
      } else {
        document.body.className = ''
      }
    }
  },
  components: {
    slideshow: Slideshow
  },
  methods: {
    init (selection) {
      this.title = selection
      import(/* webpackMode: "eager" */ `../assets/${selection}.json`).then(items => {
        this.items = items
      })
    },
    select (idx) {
      this.selected = idx
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.portfolio h2 {
  text-transform: uppercase;
  margin: 1em;
}
.about img {
  max-width: 100%;
  max-height: 500px;
}
.portfolio .photo-col {
  padding: 5px;
}
.portfolio .photo-block {
  cursor: pointer;
  transition: opacity ease 0.5s;
}
.portfolio .photo-block:hover {
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/components/Portfolio.vue